// extracted by mini-css-extract-plugin
module.exports = {"pintxo-modal__header":"BaseModalHeader_pintxo-modal__header__Ex3S8","pintxo-modal__header__slot":"BaseModalHeader_pintxo-modal__header__slot__h3XoU"};